<div class="container animated fadeInRight" *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="grid" [titulo]="'Mantenimiento de Prendas por Empleado'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #grid>
    <div class="row">
      <div class="col-md-12">
        <app-lfsa-card [innTemplate]="empleado" [titulo]="'Prendas por Empleado'" [efecto]="true" [colapseName]="'empleado'" [banderaColapse]='true'></app-lfsa-card>
        <ng-template #empleado>
          <form [formGroup]="formulario" novalidate class="form-group">
            <div class="row">
              <div [class]="'col-md-8'">
                <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('cedula')"
                  [placeholder]="'Cédula'" formControlName="cedula" [label]="'Cédula*'" [type]="'number'" [id]="'cedula'">
                </app-lfsa-input>
              </div>
              <div [class]="'col-md-4'">
                <label>&nbsp;</label><br>
                <button class="btn btn-success btn-block" (click)="buscarInfoEmpleado()">Buscar</button>
              </div>
              <div [class]="'col-md-6'">
                <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('codigo')"
                  [placeholder]="'Codigó'" formControlName="codigo" [label]="'Codigó*'" [type]="'text'" [id]="'codigo'" [isReadOnly]="true">
                </app-lfsa-input>
              </div>
              <div [class]="'col-md-6'">
                <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('ccosto')"
                  [placeholder]="'Ninguno'" formControlName="ccosto" [label]="'Centro de Costo*'" [type]="'text'" [id]="'ccosto'" [isReadOnly]="true">
                </app-lfsa-input>
              </div>
              <div [class]="'col-md-6'">
                <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('depart')"
                  [placeholder]="'Ninguno'" formControlName="depart" [label]="'Departamento*'" [type]="'text'" [id]="'depart'" [isReadOnly]="true">
                </app-lfsa-input>
              </div>
              <div [class]="'col-md-6'">
                <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('filial')"
                  [placeholder]="'Ninguno'" formControlName="filial" [label]="'Filial*'" [type]="'text'" [id]="'filial'" [isReadOnly]="true">
                </app-lfsa-input>
              </div>
              <div [class]="'col-md-12'">
                <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('fullname')"
                  [placeholder]="'Apellidos y Nombres'" formControlName="fullname" [label]="'Apellidos y Nombres*'" [type]="'text'" [id]="'fullname'" [isReadOnly]="true">
                </app-lfsa-input>
              </div>
            </div>
          </form>
          <!-- GRIDS DE CONTROL-->
          <div class="row">
            <div class="col-md-4">
              <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
              <div *ngIf="!loading">
                <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
                  No existen datos para la lista de Prendas.
                </div>
                <div *ngIf="!listaVacia">
                  <div class="row">
                    <div [class]="'col-md-12'">
                      <label><b>Prendas</b></label>
                    </div>
                  </div>
                  <div class="row">
                    <div [class]="'col-md-12'">
                      <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscarClothes" id="quickFilter "
                        (keyup)="onQuickFilterChanged()" #quickFilter />
                    </div>
                  </div>
                  <div [class]="'col-md-12'">
                    <ag-grid-angular #agGrid class=" {{clothesModulo.agGrid.class}}" [ngStyle]="clothesModulo.agGrid.style"
                      id="{{clothesModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs"
                      [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
                      >
                    </ag-grid-angular>
                  </div>
                </div>
              </div>
            </div>
            <!-- CUPOS DE EMPLEADO -->
            <div class="col-md-8">
              <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
              <div *ngIf="!loading">
                <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
                  No existen datos para la lista de Prendas.
                </div>
                <div *ngIf="!listaVacia">
                  <div class="row">
                    <div [class]="'col-md-12'">
                      <label><b>Prendas por Empleado</b></label>
                    </div>
                  </div>
                  <div class="row">
                    <div [class]="'col-md-12'">
                      <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscarClothesEmploye" id="quickFilterClothes "
                        (keyup)="onQuickFilterChangedClothesEmploye()" #quickFilter />
                    </div>
                  </div>
                  <div [class]="'col-md-12'">
                    <ag-grid-angular #agGrid class=" {{clothesEmployeModulo.agGrid.class}}" [ngStyle]="clothesEmployeModulo.agGrid.style"
                      id="{{clothesEmployeModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefsClothesEmploye"
                      [rowSelection]="rowSelectionClothesEmploye" [rowData]="rowDataSend" (gridReady)="onGridReadyClothesEmploye($event)" [pagination]="true"
                       (cellClicked)="callModalCantidad($event)">
                    </ag-grid-angular>
                  </div>
                </div>
              </div>
            </div>

            <div [class]="'col-md-4'">
              <label>&nbsp;</label><br>
              <button class="btn btn-success btn-block" (click)="saveClothesEmployee()">Guardar</button>
            </div>
            <div [class]="'col-md-4'">
              <label>&nbsp;</label><br>
              <button class="btn btn-info btn-block" (click)="printEntregas()">Ver Entregas</button>
            </div>
            <div [class]="'col-md-4'">
              <label>&nbsp;</label><br>
              <button class="btn btn-warning btn-block" (click)="resetQuotes()">Reiniciar Cupos</button>
            </div>
          </div>
        </ng-template>
        <app-lfsa-card [innTemplate]="carga" [titulo]="'Carga por fichero'" [efecto]="true" [colapseName]="'carga'" [banderaColapse]='true'></app-lfsa-card>
        <ng-template #carga>
          <form [formGroup]="formularioCarga" novalidate class="form-group">
            <div class="row col 12">
              <div class="form-group col-md-6">
                <label for="csvInput" class="letrasDanger">ArchivoCSV.csv*</label>
                <input type="file" class="form-control-file" id="csvInput" (change)="onFileSelect($event)" #fileInput
                  accept=".csv" />
              </div>
            </div>
            <br>
            <br>
          </form>
          <div class="form-group col-md-6">
            <button [disabled]="this.formularioCarga.invalid" (click)="enviarFormulario()" class="btn btn-success btn-block btn-lg">Enviar</button>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-template>
</div>
<br>

<!-- MODAL CREAR GRUPO TALLA-->
<app-lfsa-modal [innTemplate]="enviarModalCantidad" [titulo]="'Agregar Catidad a Prenda'" [idButton]="'abrirModalCantidad'" [idOpen]="'Modal'"
  [idClose]="'cerrarModalCantidad'"></app-lfsa-modal>
<ng-template #enviarModalCantidad>
  <form [formGroup]="formularioCantidad" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioCantidad.get('codbaan')"
          [placeholder]="'Codigó BAAN'" formControlName="codbaan" [label]="'Codigó BAAN'" [type]="'text'" [id]="'codbaan'" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioCantidad.get('descrp')"
          [placeholder]="'Descripción'" formControlName="descrp" [label]="'Ingrese Descripción'" [type]="'text'" [id]="'descrp'" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioCantidad.get('cantd')"
          [placeholder]="'Cantidad'" formControlName="cantd" [label]="'Ingrese Cantidad*'" [type]="'number'" [id]="'cantd'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioCantidad.invalid"
            (click)="setCantidadClothesEmploye()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>